export class Questionnaire {
  public id: string;
  public medicalQuestionIds: string[];
  public navigationUrls: string[];
  public upsellIds: string[];
  public agreementQuestionIds: string[];

  public constructor(options: {
    id: string;
    medicalQuestionIds?: string[];
    navigationUrls?: string[];
    upsellIds?: string[];
    agreementQuestionIds?: string[];
  }) {
    this.id = options.id;
    this.medicalQuestionIds = options.medicalQuestionIds || [];
    this.navigationUrls = options.navigationUrls || [];
    this.upsellIds = options.upsellIds || [];
    this.agreementQuestionIds = options.agreementQuestionIds || [];
  }
}
